import { EditorContentView } from '@modules/editor/EditorContentView';
import { Stack, Typography } from '@mui/material';
import type { Editor } from '@tiptap/react';
import { AiChatMessage } from 'src/@types/ai';
import { AISearchSources } from '../AISearchSources';
import { BotMessageLoading } from '../BotMessageLoading';
import { ThinkingHeader } from './ThinkingHeader';
import { ChatResponseStyled, StyledMarkupEditor } from './styles';
import { useAISearchThinkResponse } from './useAISearchThinkResponse';

type Props = {
  message: AiChatMessage;
  editor: Editor;
};

export const AISearchThinkResponse = ({ message, editor }: Props) => {
  const { aiResponseContent, parsedContent } = useAISearchThinkResponse({
    message,
  });

  return (
    <ChatResponseStyled>
      {/* Thinking Process */}
      {aiResponseContent.think && <ThinkingHeader message={message} />}

      {/* Final Report */}
      {parsedContent && (
        <Stack mb={2} overflow="hidden">
          <StyledMarkupEditor>
            <EditorContentView editor={editor} content={parsedContent} />
          </StyledMarkupEditor>
        </Stack>
      )}

      {/* Loading */}
      {aiResponseContent.status === 'thinking' && !parsedContent && (
        <BotMessageLoading />
      )}

      {!!aiResponseContent.searchSources?.length && (
        <AISearchSources searchSources={aiResponseContent.searchSources} />
      )}

      {aiResponseContent?.error && (
        <Stack alignItems="center" textAlign="center" mb={4}>
          <Typography variant="subtitle2" color="error">
            {aiResponseContent?.error}
          </Typography>
        </Stack>
      )}
    </ChatResponseStyled>
  );
};
